import MainLayout from "../../../../components/mainLayout";
import { PAGES } from "../../../../routes";
import audio from "../../../../assets/audio/5_6.mp3"
export default function P1() {
    return (
        <MainLayout
            title="Kto to jest Łukaszewski?"
            question=""
            audio={audio}
            answers={{
                ans1: "Dalej",
            }}
            links={{
                link1: PAGES.p14,
            }}
            content={
                <div>
                    <ul>
                        <li>A kto to jest ten Łukaszewski?</li>
                        <li>Łukaszewski prowadzi knajpę w samym środku miasteczka, obok synagogi. I dla Polaków, i dla Niemców suty posiłek poda na stół, ale i dla Żydów coś koszernego zawsze się znajdzie! Po tym znać dobrego gospodarza… Sam pędzi gorzałkę, a do niej daje salcesonu własnej roboty. Pomóż mi, a nie pożałujesz! – w jego oczach widzisz nadzieję tak dużą, że nie potrafisz odmówić.</li>
                        <li>Za mną długie kilometry, więc ani kolacji, ani noclegu nie odmówię! I ze śliwkami pomogę.</li>
                        <li>
                        Dziękuję, jestem twoim dłużnikiem! – krzyczy z radości. – Emil jestem, miło mi!
                        </li>
                    </ul>
                </div>
            }
        />

    );
}